import React from 'react';
import PropTypes from 'prop-types';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import useLink from 'Hooks/useLink';
import Relationship from 'facet-rest/src/domain/Relationship';
import TrustFile from 'Components/AdvisorApp/Viewport/ApexAdminPortal/AccountInfo/TrustFiles/TrustFile';
import DataContainer from 'Components/UI/DataContainer';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBox } from '@facet-wealth/design';

const styles = theme => ({
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

function TrustFiles({
  relationship,
  classes,
}) {
  const { collection, isInitializing, loadingError } = useLink(relationship.link('related'));
  return (
    <FDBox paddingY={2}>
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        Trust Documents
      </Typography>
      <FDBox paddingY={2}>
        <DataContainer
          loading={isInitializing}
          loadingError={loadingError}
          component={() => (
            <MetaCollectionRenderer
              collection={collection}
              layout={TrustFile}
              errors={loadingError}
            />
          )}
        />
      </FDBox>
    </FDBox>


  );
}

TrustFiles.propTypes = {
  relationship: PropTypes.instanceOf(Relationship).isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TrustFiles);
